import { useProductizedServicePreview_productizedService$key } from '#app/__generated__/relay/useProductizedServicePreview_productizedService.graphql.js';
import { useURLParameters } from '#app/hooks/useURLParameters.js';
import { graphql, useFragment } from '@contra/relay';

export const useProductizedServicePreview = (
  productizedServiceRef: useProductizedServicePreview_productizedService$key,
) => {
  const service =
    useFragment<useProductizedServicePreview_productizedService$key>(
      graphql`
        fragment useProductizedServicePreview_productizedService on ProductizedService {
          publishedAt
        }
      `,
      productizedServiceRef,
    );

  const isDraft = !service.publishedAt;
  const [urlSearchParameters] = useURLParameters('/s/@slug');
  const isPreview = urlSearchParameters.preview;

  return {
    isPreview: isPreview && isDraft,
  };
};
